import React, { useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import RouteConstants from '../../constants/routeConstants';
import Helper from '../../utility/helper';
import { useState, Downgraded } from '@hookstate/core';
import { FULL_PERMISSION, NO_ACCESS_PERMISSION } from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
// import CommonRequest from '../../sharedcomponents/commonRequest/commonRequest';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import { generatePath } from 'react-router-dom';
import AppConstants from '../../constants/appConstants';
// import StyledTableRow from '../../sharedcomponents/styledTable/styledTableRow';
// import StyledTableCell from '../../sharedcomponents/styledTable/styledTableCell';
import DataOutfitList from './dataOutfitList';
import { useHistory } from 'react-router-dom';
// import Title from '../../sharedcomponents/title/title';

const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};

const Outfit = (props) => {
    const loading = useState(false);
    const eventData = useState(null);
    const userID = useState(null);
    const allData = useState();
    // const eventState = useState([]);
    const setAll = useState(false);
    const history = useHistory()
    const [modPermission, setModPermission] = React.useState(null);
    const [participantList, setParticipantList] = React.useState(null);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: null,
        noOfPages: null,
    });
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const filteredList = useState([]);
    const filteredEmty = useState(false);

    useEffect(() => {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        if (userID.get() == null && (eventData.get() == null || (
            eventData.get() && eventData.eventID.value != eventInfo.eventID
        ))) {
            eventData.set(eventInfo);
            userID.set(userInfo.userID);
        }
        if (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo) || Helper.isEventStaff(userInfo)) {
            setModPermission(FULL_PERMISSION);
        }
        else {
            setModPermission(NO_ACCESS_PERMISSION);
        }
    }, [])
    useEffect(() => {
        if (modPermission && modPermission != NO_ACCESS_PERMISSION) {
            getOutfitList();
        }
    }, [modPermission])

    useEffect(() => {
        const gUserInfo = Helper.getStorage('userInfo');
        const gEventInfo = Helper.getStorage('eventInfo');
        if (
            Helper.isAdminUser(gUserInfo) ||
            (gUserInfo.roles && Helper.isEventAdmin(gUserInfo)) || gUserInfo.roles && Helper.isEventStaff(gUserInfo)
        ) {
            ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
            ).then((res) => {
                if (res.data.rows) {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );
                    setParticipantList(participants);
                }
            });
        }
    }, []);

    const getOutfitList = () => {
        loading.set(true);
        ApiHelper.get(APIURLConstants.GET_OUTFIT_LIST(eventData.get().eventID)).then(res => {
            if (res.data.rows) {
                let data = res.data.rows;
                data.map(item => {
                    item.expanded = false;
                    item.selected = false;
                });
                loading.set(false);

                allData.set(data);
            }
        })

    }
    const redirectToCreate = () => {
        let userIds = allData.attach(Downgraded).get().map(x => x.userID);
        let filteredParticipants = participantList.filter(x => !userIds.includes(x.userID))
        props.history.push({
            pathname: generatePath(RouteConstants.CREATE_OUTFIT, {
                eventID: eventData.get().eventID,
            }),
            state: { participantList: filteredParticipants, adminUser: true },
        });
    };
    const toggleChange = (item, index) => {
        item.expanded = !item.expanded;
        allData[index].set(item);
    }

    const onDelete = () => {
        const selected = allData.get().filter((user) => user.selected === true);
        if (selected.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to delete all request?'
                : 'Do you want to delete selected request?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    }

    const handleConfirmation = () => {
        let deleteRequests = [];
        allData.get().map((row) => {
            if (row.selected === true) {
                deleteRequests.push(row.userOutfitID);
            }
        });

        ApiHelper.post(APIURLConstants.DELETE_OUTFITS, {
            ids: deleteRequests.join(','),
            modifiedBy: userID.value,
        })
            .then((res) => {
                if (res.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request deleted successfully',
                    });
                    //props.onDelete(false);
                    setAll.set(false);
                    getOutfitList();
                }
            })
            .catch((error) => {
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const redirectToEdit = (data) => {
        const row = data;
        let userIds = allData.attach(Downgraded).get().map(x => x.userID);
        let index = userIds.indexOf(row.userID);
        userIds.splice(index, 1);
        let filteredParticipants = participantList.filter(x => !userIds.includes(x.userID));


        const path = generatePath(RouteConstants.EDIT_OUTFIT, {
            eventID: eventData.get().eventID,
            userOutfitID: row.userOutfitID,
        });
        history.push({
            pathname: path,
            state: { participantList: filteredParticipants, adminUser: true, outfitState: row },
        });

    }
    const callExport = () => {
        if (filteredList.attach(Downgraded).length !== 0 || filteredEmty.get() === true) {
            const selected = filteredList
                .get()
                .filter((user) => user.selected === true);
            const allSelected = filteredList
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0) {
                generateExcelReport(allSelected);
            } else {
                generateExcelReport(selected);
            }
        } else {
            const selected = allData
                .get()
                .filter((user) => user.selected === true);
            const allSelected = allData
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0) {
                generateExcelReport(allSelected);
            } else {
                generateExcelReport(selected);
            }

        }
    }

    const generateExcelReport = async (result) => {
        let selectedIds = [];
        let IDs = null;
        if (result.length > 0) {
            result.map((item) => {
                selectedIds.push(item.userOutfitID);
            });
            IDs = selectedIds.join(',');
        }

        await ApiHelper.post(
            APIURLConstants.Excel_Export,{
                EventID:eventData.get().eventID,
                ModuleID:5,
                IDs:IDs
            }
        ).then((res) => {
            const finalObject = JSON.parse(res.data.value);
            if (finalObject) {
                if (finalObject.length > 0) {
                    let header = {};
                    Object.keys(finalObject[0]).map((key) => {
                        header[key] = key;
                    });

                    finalObject.unshift(header);
                    Helper.downloadReport(finalObject, `Outfit-Report`);
                }
            }
        });
    };

    return (
        <Box sx={{ width: '100%' }}>
            {loading.get() ? (
                <Box style={loader}>
                    <CircularProgress />
                </Box>
            ) :
                modPermission && modPermission == NO_ACCESS_PERMISSION ?
                    <UnauthorizedUI showLogout={false} />
                    : (
                        <Box className='contentBox'>
                            <DataOutfitList
                                data={allData.attach(Downgraded).get()}
                                editRow={redirectToEdit}
                                handleClick={redirectToCreate}
                                title={''}
                                outfitInfo={true}
                                buttonTitle={'Add'}
                                deleteRows={onDelete}
                                showSearch={true}
                                searchLabel={'Search'}
                                showFilter={false}
                                showExport={true}
                                callExport={callExport}
                                moduleDisplayName={Helper.getModuleName(eventData.get() ? eventData.moduleDetails.get() : [],
                                    AppConstants.EVENT_MODULES.OUTFIT)}
                                // getResults={getRegistrationList}
                                pagingInfo={pagingInfo.attach(Downgraded).get()}
                                // handlePageChange={handlePageChange}
                                snackBarProps={snackBarProps}
                                setSnackBarProps={setSnackBarProps}
                                modPermission={modPermission}
                                toggleChange={toggleChange}
                                moduleToShow={'Outfit'}
                            />
                        </Box>
                    )}


            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
        </Box>

    )
};

export default {
    routeProps: {
        path: RouteConstants.EVENT_OUTFIT,
        component: Outfit,
    },
    name: 'Outfit',
};